import React from 'react';


const PrivacyInfoUsagePolicyMain = () => {
  return (
    <div className="PrivacyInfoUsagePolicyMain-page">
      {/* 主要内容 */}
      <main className="main-content">
        <section className="section">
          <h2>1.個人情報保護管理者の氏名又は職名、所属及び連絡先</h2>
          <p>個人情報保護管理者　代表取締役</p >
          <p>個人情報保護管理者へのご連絡は、以下の問い合せ窓口までご連絡ください</p >
        </section>

        <section className="section">
          <h2>2.個人情報の利用目的</h2>
          <p>当該フォームで取得した個人情報は、以下の目的で利用し、目的外の利用はいたしません</p >
           <table className="PrivacyInfoUsagePolicyMain-table">
        <thead>
          <tr>
            <th>対象となる個人情報</th>
            <th>利用目的</th>
          </tr>
        </thead>
        <tbody>
            <tr>
              <td>お問合せいただいた方</td>
              <td>
                <ul className="purpose-list">
                    <li>お問合せ対応のため</li>
                    <li>当社に関連するサービスのご案内のため</li>
                </ul>
              </td>
            </tr>
        </tbody>
      </table>
        </section>

        <section className="section">
          <h2>3.第三者への委託</h2>
          <p>個人情報の取扱いを外部に委託することがあります。個人情報の取扱いを外部に委託する場合は、当社が規定する個人情報管理基準を満たす事業者を選定して委託を行い、適切な取扱いが行われるよう監督します。</p >
        </section>

        <section className="section">
          <h2>4.第三者への提供</h2>
          <p>当社は、ご本人の同意がある場合または法令に基づく場合を除き、当該フォームで取得した個人情報を第三者に提供することはございません。</p >
        </section>

        <section className="section">
          <h2>5.個人情報保護のための安全管理</h2>
          <p>当社は、ご本人の個人情報を保護するための規程類を定め、従業者全員に周知・徹底と啓発・教育を図るとともに、その遵守状況の監査を定期的に実施いたします。また、ご本人の個人情報を保護するために必要な安全管理措置の維持・向上に努めてまいります。</p >
        </section>

        <section className="section">
          <h2>6.個人情報の開示等の手続</h2>
          <p>ご本人が、当社が保有するご自身の個人情報の開示等（利用目的の通知、個人情報の開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止、第三者提供記録の開示）を求める場合は、お問合せ窓口まで連絡ください。</p >
          <p>SUN FLOWER SOFT株式会社</p >
          <p>お問合せ窓口info@sunflower-soft.com</p >
        </section>

        <section className="section">
          <h2>7.個人情報をご提供いただくことの任意性</h2>
          <p>個人情報のご提供は任意ですが、ご提供いただけない場合は、第2項に記載の内容に支障がでる恐れがあります。</p >
        </section>

        <section className="section">
          <h2>8.当社Ｗｅｂサイトの運営</h2>
          <p>当社サイトでは、ご本人が当社Webサイトを再度訪問されたときなどに、より便利に閲覧していただけるよう「クッキー（Cookie）」の技術を使用することがあります。これは、ご本人のコンピュータが当社Ｗｅｂサイトのどのページに訪れたかを記録しますが、ご本人が当社Ｗｅｂサイトにおいてご自身の個人情報を入力されない限りご本人ご自身を特定、識別することはできません。
クッキーの使用を希望されない場合は、ご本人のブラウザの設定を変更することにより、クッキーの使用を拒否することができます。その場合、一部または全部のサービスがご利用いただけなくなることがあります。</p >
        </section>
      </main>
    </div>
  );
};

export default PrivacyInfoUsagePolicyMain
